$(document).ready(function() {
    require('./braintree/braintreeMFRA')();
});
